import { Skeleton, Grid } from "@mui/material";
import React from "react";

const HomeLoader = (props) => {
  const { rows = 20 } = props;

  return (
    <>
      {[...Array(rows)]?.map((item) => {
        return (
          <>
            <Grid item xs={12} sm={2} md={5} lg={5}>
              <Skeleton
                height={"300px"}
                width={"100%"}
                style={{
                  marginTop: "-62px",
                }}
              />
            </Grid>
          </>
        );
      })}
    </>
  );
};

export default HomeLoader;
